import { render, staticRenderFns } from "./pricing-profile-form.vue?vue&type=template&id=f4de15d2&scoped=true&"
import script from "./pricing-profile-form.vue?vue&type=script&lang=js&"
export * from "./pricing-profile-form.vue?vue&type=script&lang=js&"
import style0 from "./pricing-profile-form.vue?vue&type=style&index=0&id=f4de15d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4de15d2",
  null
  
)

export default component.exports